<template>
  <transition name="slide-menu">
    <div
      v-show="isMenuExpanded"
      v-on-clickaway="handleExpandedMenuClickaway"
      class="header-mobile-expanded__wrapper"
    >
      <div
        ref="container"
        class="header-mobile-expanded__menu-container"
        :style="wrapperStyles"
      >
        <header-expanded-top-section
          :is-notifications-icon-active="isNotificationsIconActive"
          :is-user-icon-active="isUserIconActive"
          @close-menu="closeMenu"
          @notification-icon-click="onNotificationIconClick"
          @user-icon-click="onUserIconClick"
        />

        <component
          :is="currentComponent"
          :menu-list="menuList"
          @close-menu="closeMenu"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { BUTTON_STYLE } from 'shared/AButton/index.vue'
import AIcon from 'shared/AIcon'
import AHeaderMenuBlock from './AHeaderMenuBlock'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { hasParentWith } from '@fmpedia/helpers'
import { HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE } from 'enums/data-attributes'
import { directive as onClickaway } from 'vue-clickaway'
import HeaderExpandedTopSection from '@/components/AHeader/AHeaderMobile/AHeaderMobileExpanded/HeaderExpandedTopSection/index.vue'
import HeaderExpandedNavigation from '@/components/AHeader/AHeaderMobile/AHeaderMobileExpanded/HeaderExpandedNavigation/index.vue'
import ANotifications from '@/components/AHeader/Shared/AHeaderActions/ANotifications/index.vue'
import AUserMenu from '@/components/AHeader/Shared/AUserMenu/index.vue'

const BASE_BOTTOM_PADDING = 50

export default {
  name: 'AHeaderMobileExpanded',
  mixins: [hydrationHelpers],
  components: {
    AUserMenu,
    ANotifications,
    HeaderExpandedNavigation,
    HeaderExpandedTopSection,
    AHeaderMenuBlock,
    AIcon
  },
  props: {
    menuList: propValidator([PROP_TYPES.ARRAY]),
    isMenuExpanded: propValidator([PROP_TYPES.BOOLEAN])
  },
  directives: { onClickaway },
  consts: {
    BUTTON_STYLE
  },
  data() {
    return {
      currentComponent: HeaderExpandedNavigation
    }
  },
  computed: {
    ...mapState({
      isSafari: state => state.isSafari,
      isIPhone: state => state.isIPhone
    }),
    ...mapGetters({
      mobileBottomPadding: 'mobileBottomPadding',
      isLoggedIn: 'auth/isLoggedIn'
    }),
    wrapperStyles() {
      return {
        paddingBottom: `${this.mobileBottomPadding + BASE_BOTTOM_PADDING}px`
      }
    },
    isNotificationsIconActive() {
      return this.currentComponent === ANotifications
    },
    isUserIconActive() {
      return this.currentComponent === AUserMenu
    }
  },
  watch: {
    isLoggedIn(newVal) {
      if (!newVal) {
        this.showNavigationMenu()
        this.scrollContainerToTheTop()
      }
    },
    isMenuExpanded: {
      handler(newVal) {
        if (!newVal) {
          this.showNavigationMenu()
          this.scrollContainerToTheTop()
        }

        if (newVal) return this.$_hydrationHelpers_hideScroll()

        this.$_hydrationHelpers_showScroll()
      }
    }
  },
  methods: {
    scrollContainerToTheTop() {
      this.$refs.container.scrollTop = 0
    },
    closeMenu() {
      this.$emit('onCloseMenu')
    },
    handleExpandedMenuClickaway(e) {
      if (this.checkIfMenuOpenBtnClicked(e) || !this.isMenuExpanded) return

      this.closeMenu()
    },
    checkIfMenuOpenBtnClicked(e) {
      return hasParentWith(e.target, {
        attribute: HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE
      })
    },
    showNotifications() {
      this.currentComponent = ANotifications
    },
    showNavigationMenu() {
      this.currentComponent = HeaderExpandedNavigation
    },
    showUserMenu() {
      this.currentComponent = AUserMenu
    },
    onNotificationIconClick() {
      if (!this.isNotificationsIconActive) {
        this.showNotifications()
      } else {
        this.showNavigationMenu()
      }
    },
    onUserIconClick() {
      if (!this.isUserIconActive) {
        this.showUserMenu()
      } else {
        this.showNavigationMenu()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-menu-enter,
.slide-menu-leave-to {
  transform: translateY(100%);
}

.slide-menu-enter-to,
.slide-menu-leave-from {
  transform: translateY(0);
}

.slide-menu-enter-active,
.slide-menu-leave-active {
  transition: transform 0.3s ease;
  transform-origin: bottom center;
}

.header-mobile-expanded__wrapper {
  position: fixed;
  z-index: $z-index-mobile-expanded-menu;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $c--gray-darkest;

  .header-mobile-expanded__menu-container {
    height: 100vh;
    width: 100%;
    padding: 24px 24px 10px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    /deep/ .input__wrapper {
      border: none;
    }
  }

  /deep/ .notifications__wrapper,
  .user-menu__wrapper {
    margin-top: 24px;
  }
}
</style>
